import React from 'react';
import { translations } from '../data/translations';
import { Sparkles, Calculator, Heart } from 'lucide-react';

const VisionSection = ({ lang }) => {
  const t = translations[lang].vision;
  
  const getIcon = (index) => {
    const icons = [
      <Sparkles className="w-6 h-6" />,
      <Calculator className="w-6 h-6" />,
      <Heart className="w-6 h-6" />
    ];
    return icons[index];
  };
  
  return (
    <section id="vision" className="bg-[#0a0a0a] py-24 md:py-32 relative overflow-hidden">
      {/* Subtle background accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#00FFD1]/5 rounded-full blur-[150px] pointer-events-none" />
      
      <div className="max-w-6xl mx-auto px-6 lg:px-16 relative z-10">
        {/* Section Label */}
        <div className="mb-6 text-center">
          <span className="text-[#00FFD1] text-sm font-medium tracking-wider uppercase">
            {t.label}
          </span>
        </div>
        
        {/* Title */}
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white leading-[1.1] tracking-[-0.02em] mb-16 text-center">
          {t.title}
        </h2>
        
        {/* Vision Cards Grid */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {t.cards.map((card, index) => (
            <div
              key={card.id}
              className={`
                relative p-8 border transition-all duration-400 group
                ${card.highlighted 
                  ? 'bg-[#00FFD1]/5 border-[#00FFD1]/40 hover:border-[#00FFD1]' 
                  : 'bg-black/50 border-white/15 hover:border-white/30'
                }
              `}
            >
              {/* Highlighted badge */}
              {card.highlighted && (
                <div className="absolute -top-3 left-8">
                  <span className="inline-flex items-center px-3 py-1 bg-[#00FFD1] text-black text-xs font-semibold tracking-wider uppercase">
                    {lang === 'en' ? 'Core Mission' : 'Misión Central'}
                  </span>
                </div>
              )}
              
              {/* Icon */}
              <div className={`
                w-12 h-12 flex items-center justify-center mb-6
                ${card.highlighted ? 'text-[#00FFD1]' : 'text-white/60 group-hover:text-[#00FFD1]'}
                transition-colors duration-300
              `}>
                {getIcon(index)}
              </div>
              
              {/* Card Title */}
              <h3 className={`
                text-xl font-semibold mb-4
                ${card.highlighted ? 'text-[#00FFD1]' : 'text-white'}
              `}>
                {card.title}
              </h3>
              
              {/* Card Description */}
              <p className="text-base text-white/70 leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VisionSection;
